import { Button } from "@gigpro/ui/Button";
import { Dialog, DialogFooter } from "@gigpro/ui/Dialog";
import { ArrowLeft, Home } from "@gigpro/ui/Icons";
import { Link } from "react-router";

import { ROUTES, buildRoute } from "routing/Routes";

type MaintenanceModeDialogProps = {
  open: boolean;
  onBack: () => void;
};

export const maintenanceRoutes: Array<string> = [buildRoute(ROUTES.LOCATIONS.DETAILS.GIG_ADD, {})];

export function MaintenanceModeDialog({ open, onBack }: Readonly<MaintenanceModeDialogProps>) {
  return (
    <Dialog open={open}>
      <div className="flex flex-col items-center gap-4 text-center">
        <p className="text-[4rem]">🛠️</p>
        <h1 className="text-huge font-semibold">We're down for maintenance</h1>
        <p className="text-large">We're working hard to get things back up and running as soon as possible.</p>
        <p className="text-large">Thank you for your patience.</p>
      </div>
      <DialogFooter>
        <Button className="w-full" variant="outlined" onClick={onBack}>
          <ArrowLeft className="mr-1 size-4" />
          Back
        </Button>
        <Button className="w-full" variant="contained" asChild>
          <Link to={buildRoute(ROUTES.LOCATIONS.DETAILS.HOME, {})}>
            <Home className="mr-1 size-4" />
            Home
          </Link>
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
